export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 992;
export const DESKTOP_BREAKPOINT = 1200;
